import { defineStore } from "pinia";
import { ref } from "vue";
import {
  type CreateLocationRequest,
  type LocationDto,
  LocationService,
} from '@/client';

export const useLocationsStore = defineStore("locations", () => {
  const locations = ref<LocationDto[]>([]);

  async function list() {
    return await LocationService.getApiLocationGetAll()
      .then((data) => {
        locations.value = (data as LocationDto[]).sort((a, b) => a.name!.localeCompare(b.name!));
        return Promise.resolve();
      })
      .catch((error: any) => Promise.reject(error));
  }

  async function get(locationId: string) {
    return await LocationService.getApiLocationGetById({ id: locationId })
      .then((data) => Promise.resolve(data as LocationDto))
      .catch((error: any) => Promise.reject(error));
  }

  async function exists(name: string) {
    return await LocationService.getApiLocationExsistsById({ id: name })
      .then((data) => Promise.resolve(data as boolean))
      .catch((error: any) => Promise.reject(error));
  }

  async function create(location: CreateLocationRequest) {
    return await LocationService.postApiLocationCreate({ requestBody: location })
      .then((data) => Promise.resolve(data))
      .catch((error: any) => Promise.reject(error));
  }

  async function clone(id: string) {
    return await LocationService.postApiLocationClone({ requestBody: { id } })
      .then(() => Promise.resolve())
      .catch((error: any) => Promise.reject(error));
  }

  async function update(location: LocationDto) {
    return await LocationService.postApiLocationUpdate({ requestBody: location })
      .then((data) => Promise.resolve(data))
      .catch((error: any) => Promise.reject(error));
  }

  async function deleteLocation(locationId: string) {
    return await LocationService.deleteApiLocationById({ id: locationId })
      .then(() => Promise.resolve())
      .catch((error: any) => Promise.reject(error));
  }

  return {
    locations,
    list,
    get,
    create,
    update,
    clone,
    deleteLocation,
    exists
  };
});
